export default "__VITE_ASSET__KlUdSHxj__"